import QuotationHorizontalStepsFcl from "./quotation-horizonatal-steps-fcl.component";

export default QuotationHorizontalStepsFcl;
